import { LucideIcon } from "lucide-react";
import { Card } from "../ui/card";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  variant?: 'blue' | 'purple' | 'green';
}

export function StatCard({ 
  title, 
  value, 
  icon: Icon, 
  description, 
  trend, 
  className,
  variant = 'blue' 
}: StatCardProps) {
  const gradients = {
    blue: 'from-blue-600/20 to-blue-600/5 [&>div>div:last-child>svg]:text-blue-600',
    purple: 'from-purple-600/20 to-purple-600/5 [&>div>div:last-child>svg]:text-purple-600',
    green: 'from-green-600/20 to-green-600/5 [&>div>div:last-child>svg]:text-green-600'
  };

  return (
    <Card className={cn(
      "relative overflow-hidden transition-all hover:shadow-lg",
      "bg-gradient-to-br",
      gradients[variant],
      className
    )}>
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-3">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <div>
              <h3 className="text-3xl font-bold">{value}</h3>
              {description && (
                <p className="text-sm text-muted-foreground mt-1">{description}</p>
              )}
            </div>
            {trend && (
              <p className={cn(
                "text-sm font-medium flex items-center gap-1",
                trend.isPositive ? "text-green-600" : "text-red-600"
              )}>
                {trend.isPositive ? "+" : "-"}{trend.value}%
                <span className="text-muted-foreground ml-1">geçen aya göre</span>
              </p>
            )}
          </div>
          <div className="h-12 w-12 rounded-full bg-background/10 flex items-center justify-center backdrop-blur-sm">
            <Icon className="h-6 w-6" />
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-background/20 to-background/5" />
    </Card>
  );
}
